import { Icon, Stack, IconButton } from '@fluentui/react';
import { useDrag } from '@use-gesture/react';
import { useAllRowsClosedContext } from '../../../../../_grid/contexts/allRowsClosedContext';
import { useExpandedGridContext } from '../../../../../_grid/contexts/expandedContext';
import { BORDER, TOP_HEADERS_HEIGHT } from '../../CONSTANTS';
import { useCallback, useMemo } from 'react';
import { useGridLayoutContext } from '../../context/LayoutContext';
import { useSortContext } from '../../context/SortContext';
import { SortDirection, SortType } from '../../../../../../../api/generated/data-contracts';

export const GridHeader = () => {
    const { setExpandedRows } = useExpandedGridContext();
    const allRowsClosed = useAllRowsClosedContext();
    const { rowHeaderSize, setRowHeaderSize } = useGridLayoutContext();
    const bind = useDrag(({ down, memo, movement: [mx] }) => {
        if (!down) {
            return;
        }
        if (!memo) {
            return rowHeaderSize;
        }
        const newX = memo + mx;
        setRowHeaderSize(newX);
    }, {});
    return (
        <div
            style={{
                background: 'white',
                borderBottom: BORDER,
                borderRight: BORDER,
                boxSizing: 'border-box',
                zIndex: 2,
                width: `${rowHeaderSize}px`,
                height: TOP_HEADERS_HEIGHT,
                position: 'sticky',
                left: 0,
                display: 'flex',
                // flexDirection: "row"
            }}
        >
            <Stack horizontal horizontalAlign="start" verticalAlign="end" styles={{ root: { width: '100%', paddingBottom: 10 } }}>
                <IconButton
                    iconProps={{ iconName: 'CalculatorAddition' }}
                    title="Expand all"
                    onClick={() => {
                        setExpandedRows(expanded => {
                            return Object.fromEntries(Object.keys(expanded).map(key => [key, true]));
                        });
                    }}
                />
                <IconButton
                    iconProps={{ iconName: 'CalculatorSubtract' }}
                    title="Collapse all"
                    disabled={allRowsClosed}
                    onClick={() => {
                        setExpandedRows(expanded => {
                            return Object.fromEntries(Object.keys(expanded).map(key => [key, false]));
                        });
                    }}
                />
                <SortNameButton />
            </Stack>

            <Stack
                verticalAlign="center"
                {...bind()}
                horizontalAlign="end"
                styles={{
                    root: {
                        '& > div': {
                            opacity: 0,
                            transition: '.3s ease',
                            userSelect: 'none',
                        },
                        '&:hover > div': {
                            opacity: 1,
                        },
                        touchAction: 'none',
                        width: 50,
                        cursor: 'col-resize',
                        paddingRight: 5,
                    },
                }}
            >
                <div>
                    <Icon iconName="ImportMirrored" title="Resize resource column" />
                </div>
            </Stack>
        </div>
    );
};

const id = 'Name';
const SortNameButton = () => {
    const { sort, setSort } = useSortContext();

    const onClick = useCallback(() => {
        setSort(currentSort => {
            let direction = SortDirection.Ascending;
            if (currentSort?.type === SortType.Property && currentSort?.key === id && currentSort?.direction === SortDirection.Ascending) {
                direction = SortDirection.Descending;
            }
            return { direction, key: id, type: SortType.Property };
        });
    }, [setSort]);

    const iconName = useMemo(() => {
        if (!sort || sort.key !== id) {
            return 'Sort';
        }
        if (sort.direction === SortDirection.Ascending) {
            return 'SortUp';
        }
        return 'SortDown';
    }, [sort]);

    return <IconButton iconProps={{ iconName }} onClick={onClick} />;
};
